import { getApi } from '@/shared/api';
import store from '@/app/store';
import { yaCounterByHostname } from '@/shared/lib/helpers/yandexCounter';

export default async function () {
	try {
		store.commit('SET_GLOBAL_PRELOADER', true);

		const response = await getApi('/k5/v1/user/init');
		if (response.data.status === true && response.data.data?.user) {
			store.commit('SET_USER', response.data.data.user);
			if (window.ym) {
				window.ym(yaCounterByHostname(), 'userParams', {
					UserID: store.state.user.uid,
					IsNewUser: !store.state.user.have_contracts,
					TypeAhs: store.state.user.ahs === '' ? 'Null' : store.state.user.ahs,
				});
			}

			if (response.data.data.user.current_contract) {
				// response.data.data.user.current_contract.date_return = new Date('2025-02-19');
				store.commit('SET_ACTIVE_CONTRACT', response.data.data.user.current_contract);
			}
			if (response.data.data.user.current_loan_app) {
				store.commit('SET_LOAN', response.data.data.user.current_loan_app);
				store.commit('SET_CENTRIFUGE_STATUS', {
					...store.state.centrifugeStatus,
					loanStatus: response.data.data.user.current_loan_app.status?.slug,
				});
			}
		}

		console.log('USER: ', response);
	} catch (error) {
		console.log(error);
		store.commit('SET_INIT_ERROR', error.data.user_message || 'Непредвиденная ошибка. Пожалуйста, попробуйте позже или обратитесь в службу поддержки, чтобы уточнить детали');
		store.commit('LOGOUT');
	} finally {
		store.commit('SET_GLOBAL_PRELOADER', false);
	}
}
